import { render, staticRenderFns } from "./DialogBase.vue?vue&type=template&id=a2142c2e&scoped=true"
import script from "./DialogBase.vue?vue&type=script&lang=js"
export * from "./DialogBase.vue?vue&type=script&lang=js"
import style0 from "./DialogBase.vue?vue&type=style&index=0&id=a2142c2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2142c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2142c2e')) {
      api.createRecord('a2142c2e', component.options)
    } else {
      api.reload('a2142c2e', component.options)
    }
    module.hot.accept("./DialogBase.vue?vue&type=template&id=a2142c2e&scoped=true", function () {
      api.rerender('a2142c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogBase.vue"
export default component.exports